import {
  EnumSurveyAnswerStatus,
  EnumTypeTexts,
} from "../../../Common/Enums/EnumsTypes";
import { RadioPropsTypes } from "../RadioPropsTypes";
import "../SCSS/styles.css";

function Radio({
  handleChangeInputYesOrNo,
  surveyAnswers,
  questionObjVariable,
  questionId,
  isPreview,
  surveyAnswersInfo,
}: RadioPropsTypes) {
  return (
    <>
      <div className="supplier-view-radio-cover">
        <div
          className={
            surveyAnswers?.[questionId!]?.val === EnumTypeTexts.YES
              ? "supplier-view-radio yes"
              : "supplier-view-radio"
          }
          onClick={(e) =>
            !isPreview &&
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
            handleChangeInputYesOrNo!(
              questionId!,
              EnumTypeTexts.YES,
              Number(
                questionObjVariable?.[questionId!]?.optionInfo?.optionObj[
                  questionObjVariable?.[questionId!]?.optionInfo
                    ?.optionOrder?.[0]
                ]?.weightage
              ),
              questionObjVariable!?.[questionId!]?.optionInfo?.optionOrder?.[0]
            )
          }
        >
          Yes
        </div>
        <div
          className={
            surveyAnswers?.[questionId!]?.val === EnumTypeTexts.NO
              ? "supplier-view-radio no"
              : "supplier-view-radio"
          }
          onClick={(e) =>
            !isPreview &&
            surveyAnswersInfo?.surveyStatus !==
              EnumSurveyAnswerStatus?.COMPLETED &&
            !surveyAnswers?.[questionId!]?.notApplicableInfo?.isNotApplicable &&
            handleChangeInputYesOrNo!(
              questionId!,
              EnumTypeTexts.NO,
              Number(
                questionObjVariable?.[questionId!]?.optionInfo?.optionObj[
                  questionObjVariable?.[questionId!]?.optionInfo
                    ?.optionOrder?.[1]
                ]?.weightage
              ),
              questionObjVariable!?.[questionId!]?.optionInfo?.optionOrder?.[1]
            )
          }
        >
          No
        </div>
      </div>
    </>
  );
}

export default Radio;
